module.exports = __webpack_public_path__ + "img/platform_logo.35e4bb64.png";